module.exports = __webpack_public_path__ + "media/images/icon-bestplan-c0f329b4241158d352d84324e302cfd6.png";